export const env_config = {
  "identityEndPoint": "/auth",
  "proxy-api-host": "https://app.sparxo.com",
  "event-host": "https://e.sparxo.com",
  "blavity-shop-host": "https://shop.blavity.com"
};
